module.exports = __webpack_public_path__ + "img/imetsc.425d2a02.png";